var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.editLink,"title":"Edit","target":"_blank","rel":"noopener"}},[_c('feather-icon',{staticClass:"cursor-pointer",attrs:{"icon":"EditIcon","color":"black"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }